import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCQueenSvania extends NPC {
    constructor() {
        super(definitions.NPC_ID.QUEEN_SVANIA);

        this.collisionRadius = 30;
        this.collisionOffsetX = -14;
        this.collisionOffsetY = -30;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_queen_svania_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(8, -12));
        this.animateIdle(1);
    }
}